import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { recordCustomerActivity, type CustomerActivity } from '@/lib/customer-activity'

export default function CustomerActivityMonitor() {
  const { b2bCustomer, isAdmin, isLoading } = useAuth()
  const { pathname } = useLocation()
  const id = !isLoading && !isAdmin && b2bCustomer?.status === 'approved' ? b2bCustomer.id : null
  useEffect(() => {
    const event: CustomerActivity = ({ '/catalogo': 'catalog', '/carrinho': 'cart', '/checkout': 'checkout' } as Record<string, CustomerActivity>)[pathname] || 'access'
    recordCustomerActivity(id, event)
  }, [id, pathname])
  return null
}
